import Axios from 'axios';
import Cookies from 'js-cookie';

export const baseURL = process.env.REACT_APP_API_BASE_URL || '';

export const axios = Axios.create({
  baseURL,
});

export const api = {
  get: <T>(url: string, params?: object) =>
    axios.get<T>(url, {
      headers: {
        authorization: Cookies.get('token'),
      },
      ...params,
    }),
  post: <T>(url: string, data: unknown) =>
    axios.post<T>(url, data, {
      headers: {
        authorization: Cookies.get('token'),
      },
    }),
  patch: <T>(url: string, data: unknown) =>
    axios.patch<T>(url, data, {
      headers: {
        authorization: Cookies.get('token'),
      },
    }),
  delete: <T>(url: string) =>
    axios.delete<T>(url, {
      headers: {
        authorization: Cookies.get('token'),
      },
    }),
};
